import { useEffect, useState } from 'react';
import { loadStudioProject, rememberStudioProject } from '../services/studio-project';

export function useStudioProject(id: string | null) {
  const [configuration, setConfiguration] = useState<Awaited<ReturnType<typeof loadStudioProject>>>();
  const [error, setError] = useState('');
  useEffect(() => {
    if (!id) return;
    let active = true;
    const raw = new URLSearchParams(location.search).get('revision');
    const revision = raw === null ? undefined : Number(raw);
    void loadStudioProject(id, revision).then(value => {
      if (!active) return;
      rememberStudioProject(value.ride, value.project); setConfiguration(value);
    }).catch(cause => { if (active) setError(cause instanceof Error ? cause.message : 'The Studio project could not be opened.'); });
    return () => { active = false; };
  }, [id]);
  return { configuration, error };
}
